import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import getPlural from "ati-utils/pluralize";

import RecurrentPayment from "./RecurrentPayment";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";
import interpolate from "../../../../../locales/interpolate";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const getFormatedDate = (dateString) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${day < 10 ? "0" : ""}${day}.${
    month < 10 ? "0" : ""
  }${month}.${year}`;
};

const GuaranteedPayment = () => {
  const { profile, baseUrl, locale } = useStore();
  const user = profile.user;

  if (!user.guaranteed_payment) {
    return null;
  }

  const dateString = getFormatedDate(user.guaranteed_payment.paid_before);

  const daysRemaining = user.guaranteed_payment.remaining_days;
  const { profile_remainPluralize, profile_daysRemainingPluralize } = strings;

  const daysRemainingString = getPlural(
    {
      zero: ` ${profile_remainPluralize.many}\xa0${daysRemaining}\xa0${profile_daysRemainingPluralize.many}`,
      one: ` ${profile_remainPluralize.one}\xa0${daysRemaining}\xa0${profile_daysRemainingPluralize.one}`,
      few: ` ${profile_remainPluralize.few}\xa0${daysRemaining}\xa0${profile_daysRemainingPluralize.few}`,
      many: ` ${profile_remainPluralize.many}\xa0${daysRemaining}\xa0${profile_daysRemainingPluralize.many}`,
      other: ` ${profile_remainPluralize.other}\xa0${daysRemaining}\xa0${profile_daysRemainingPluralize.other}`,
    },
    daysRemaining,
    locale
  );

  const isInvoiceType = user.guaranteed_payment.invoice_pay_type_id === 1;

  return (
    <>
      <div className={cx("guaranteed-area")}>
        <div className={cx("payed-days-guaranteed")}>
          <span className={cx("red-text")}>
            {strings.profile_guaranteedPayment}
          </span>
          <span className={cx("red-text")}>{daysRemainingString}</span>
          <span className={cx("pay-before-text")}>
            {interpolate(strings.profile_payBefore, {
              val: dateString,
            })}
          </span>
        </div>
        <div className={cx("guaranteed-area-buttons")}>
          <a
            className={cx(
              "glz-button",
              "glz-is-small",
              "glz-is-primary",
              "pay-button"
            )}
            href={`https://billing.${baseUrl}/${
              isInvoiceType ? "invoice" : "kvitanciya"
            }?invoiceid=${
              user.guaranteed_payment.invoice_id
            }&utm_source=header&utm_campaign=new_header`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              sendNavigationMetric(
                isInvoiceType
                  ? "GUARANTEED_PAYMENT_INVOICE"
                  : "GUARANTEED_PAYMENT_KVITANCIYA"
              )
            }
          >
            {strings.profile_pay}
          </a>
          <a
            href={`https://${baseUrl}/GuaranteedPaymentAgreement.aspx?utm_source=header&utm_campaign=new_header`}
            className={cx("glz-link")}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => sendNavigationMetric("GUARANTEED_PAYMENT_AGREEMENT")}
          >
            {strings.profile_conditions}
          </a>
        </div>
      </div>
      <RecurrentPayment />
    </>
  );
};

export default observer(GuaranteedPayment);
